import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { FaArrowRight, FaRobot, FaGamepad, FaStar, FaSatellite, FaCube } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import chatbotImg from "../../assets/images/exp_chatbot.jpg";
import softwareAiImg from "../../assets/images/exp_software_ai.jpg";
import thirdControllerImg from "../../assets/images/exp_thirdcontroller.jpg";
import starImg from "../../assets/images/exp_star.jpg";
import satellitesImg from "../../assets/images/exp_satellites.jpg";
import officeImg from "../../assets/images/exp_office.jpg";
import { Context } from "../../context";
import classes from "./ExperimentsHome.module.css";

const latestExperiments = [
  {
    id: 11,
    title: "Chatbot AI",
    tag: "AI",
    img: chatbotImg,
    url: "https://chatbot-ai.davidebalice.dev/",
    icon: <FaRobot />,
    featured: true,
  },
  {
    id: 15,
    title: "Software AI",
    tag: "AI",
    img: softwareAiImg,
    url: "https://chatbot-ai.davidebalice.dev/ecommerce-ai/index.html",
    icon: <FaRobot />,
    featured: false,
  },
  {
    id: 10,
    title: "Third Person Controller",
    tag: "3D",
    img: thirdControllerImg,
    url: "https://third-person-controller.davidebalice.dev/",
    icon: <FaGamepad />,
    featured: false,
  },
  {
    id: 12,
    title: "Star Explorer",
    tag: "3D",
    img: starImg,
    url: "https://star-explorer.davidebalice.dev/",
    icon: <FaStar />,
    featured: false,
  },
  {
    id: 13,
    title: "Satellites Tracking",
    tag: "AI",
    img: satellitesImg,
    url: "https://satellites-tracking.davidebalice.dev/",
    icon: <FaSatellite />,
    featured: false,
  },
  {
    id: 17,
    title: "Office",
    tag: "3D",
    img: officeImg,
    url: "https://workroom.davidebalice.dev/",
    icon: <FaCube />,
    featured: false,
  },
];

const ExperimentsHome = () => {
  const { lang } = useContext(Context);
  const [hoveredId, setHoveredId] = useState(null);
  const navigate = useNavigate();

  const handleCardClick = (e, url, id) => {
    if (url.startsWith("/")) {
      e.preventDefault();
      navigate(url);
    }
  };

  return (
    <section className={classes.section}>
      <div className={classes.gridBg} />

      <div className={classes.inner} >
        {/* Header */}
        <motion.div
          className={classes.header}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
        >
          <div>
            <div className={classes.preTitle}>
              <span className={classes.prompt}>$</span>
              <span className={classes.preTitleCmd}>
                {lang === "it" ? "ls ./last-experiments" : "ls ./latest-experiments"}
              </span>
              <span className={classes.cursor} />
            </div>
            <h2 className={classes.title}>
              {lang === "it" ? "Ultimi esperimenti" : "Latest Experiments"}
            </h2>
            <p className={classes.subtitle}>
              <span className={classes.commentSlash}>{"// "}</span>
              {lang === "it"
                ? "Progetti interattivi con intelligenza artificiale e tecnologie 3D"
                : "Interactive projects with artificial intelligence and 3D technologies"}
            </p>
          </div>

          <NavLink to="/experiments" className={classes.viewAllLink}>
            {lang === "it" ? "Vedi tutti" : "View all"}
            <FaArrowRight className={classes.arrowIcon} />
          </NavLink>
        </motion.div>

        {/* Cards grid */}
        <div className={classes.grid}>
          {latestExperiments.map((exp, i) => {
            const targetUrl = exp.url;
            const targetAttr = !exp.url.startsWith("/") ? "_blank" : "_self";
            return (
              <motion.a
                key={exp.id}
                href={targetUrl}
                target={targetAttr}
                rel="noreferrer"
                onClick={(e) => handleCardClick(e, exp.url, exp.id)}
                className={`${classes.card} ${exp.featured ? classes.cardFeatured : ""}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.07 }}
                onMouseEnter={() => setHoveredId(exp.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Mac-style title bar */}
                <div className={classes.titleBar}>
                  <div className={classes.dots}>
                    <span className={`${classes.dot} ${classes.dotRed}`} />
                    <span className={`${classes.dot} ${classes.dotYellow}`} />
                    <span className={`${classes.dot} ${classes.dotGreen}`} />
                  </div>
                  <span className={classes.tabName}>{exp.title}.js</span>
                </div>

                {/* Image */}
                <div className={classes.imgWrapper}>
                  <img
                    src={exp.img}
                    alt={exp.title}
                    className={`${classes.img} ${hoveredId === exp.id ? classes.imgZoom : ""}`}
                  />
                  <div className={classes.imgOverlay} />
                </div>

                {/* Content */}
                <div className={classes.cardContent}>
                  <span
                    className={`${classes.tag} ${exp.tag === "AI" ? classes.tagAi : classes.tag3d}`}
                  >
                    {exp.tag}
                  </span>

                  <div className={classes.cardBottom}>
                    <h3 className={classes.cardTitle}>{exp.title}</h3>
                  </div>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExperimentsHome;
